import React from "react";
import { Link } from "react-router-dom";
import {
  Home,
  Info,
  FileText,
  Shield,
  Scale,
  Map,
  ExternalLink,
} from "lucide-react";
import { Helmet } from "react-helmet-async";

export default function Sitemap() {
  const sections = [
    {
      title: "Main",
      icon: <Home className="h-5 w-5" />,
      links: [
        { name: "Home", path: "/" },
        { name: "About", path: "/about" },
      ],
    },
    {
      title: "Legal",
      icon: <Scale className="h-5 w-5" />,
      links: [
        { name: "Terms of Service", path: "/terms" },
        { name: "Privacy Policy", path: "/privacy" },
        { name: "GDPR Policy", path: "/gdpr" },
      ],
    },
    {
      title: "Support",
      icon: <Info className="h-5 w-5" />,
      links: [
        { name: "Contact Us", path: "/contact" },
        { name: "Affiliate Disclosure", path: "/affiliate-disclosure" },
      ],
    },
    {
      title: "Resources",
      icon: <FileText className="h-5 w-5" />,
      links: [
        {
          name: "CoinGecko API",
          path: "https://www.coingecko.com/api",
          external: true,
        },
        {
          name: "Bitcoin Documentation",
          path: "https://bitcoin.org/en/documentation",
          external: true,
        },
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <title>Sitemap | Lo-Fee.com</title>
        <meta
          name="description"
          content="Navigate Lo-Fee.com easily with our complete sitemap. Find all resources for comparing Bitcoin exchange fees across Canadian cryptocurrency platforms."
        />
        <link rel="canonical" href="https://lo-fee.com/sitemap" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="space-y-8">
          <header className="space-y-4">
            <div className="flex items-center gap-3">
              <Map className="h-8 w-8 text-[--accent]" />
              <h1 className="text-4xl font-bold tracking-tight">Sitemap</h1>
            </div>
            <p className="text-lg text-[--text-secondary]">
              A complete overview of all pages and resources available on
              Lo-Fee.com
            </p>
          </header>

          <div className="grid sm:grid-cols-2 gap-8">
            {sections.map((section, index) => (
              <section key={index} className="space-y-4">
                <div className="flex items-center gap-2 text-[--accent]">
                  {section.icon}
                  <h2 className="text-xl font-bold">{section.title}</h2>
                </div>
                <ul className="space-y-2">
                  {section.links.map((link: any, linkIndex: number) => (
                    <li key={linkIndex}>
                      {link.external ? (
                        <a
                          href={link.path}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-2 text-[--text-secondary] hover:text-[--accent] transition-colors"
                        >
                          {link.name}
                          <ExternalLink className="h-4 w-4" />
                        </a>
                      ) : (
                        <Link
                          to={link.path}
                          className="text-[--text-secondary] hover:text-[--accent] transition-colors"
                        >
                          {link.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>

          <section className="bg-[--bg-secondary] border-2 border-[--border-color] p-6 rounded-lg">
            <div className="flex items-start gap-4">
              <Shield className="h-6 w-6 text-[--accent] flex-shrink-0" />
              <div>
                <h2 className="text-lg font-bold mb-2">Security Notice</h2>
                <p className="text-[--text-secondary]">
                  All pages on Lo-Fee.com are served over HTTPS to ensure secure
                  communication. We regularly update our security measures to
                  protect our users.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
